import { MD3LightTheme as DefaultTheme } from 'react-native-paper';

export const theme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    primary: '#6200ea',
    secondary: '#03dac6',
    background: '#f5f5f5',
    surface: '#ffffff',
    accent: '#03dac6',
    error: '#cf6679',
    text: '#000000',
    onSurface: '#000000',
    disabled: '#cccccc',
    placeholder: '#999999',
    backdrop: 'rgba(0, 0, 0, 0.5)',
  },
};

export const colors = {
  primary: '#6200ea',
  secondary: '#03dac6',
  background: '#f5f5f5',
  surface: '#ffffff',
  error: '#cf6679',
  text: '#000000',
  textSecondary: '#666666',
  border: '#e0e0e0',
  success: '#4caf50',
  warning: '#ff9800',
  info: '#2196f3',
};